import type { EventoSimulacao } from '../types';

/**
 * Junta a página nova de eventos ao que já está na tela, em ordem de seq. O polling pode trazer
 * de novo o que já chegou (resposta atrasada, reconexão, duas leituras em voo): o evento é
 * imutável no core, então o primeiro que chegou fica e a repetição, por id ou por seq, é
 * descartada.
 *
 * Sem evento novo, devolve o próprio `atuais`: o polling roda a cada 1 s ou 5 s, e um array novo
 * a cada ciclo invalidaria os selectors e redesenharia a conversa inteira sem mudança nenhuma.
 */
export const mesclarEventos = (
  atuais: EventoSimulacao[],
  novos: EventoSimulacao[],
): EventoSimulacao[] => {
  const porSeq = new Map<number, EventoSimulacao>();
  const ids = new Set<string>();
  const acrescentar = (evento: EventoSimulacao): boolean => {
    if (ids.has(evento.id) || porSeq.has(evento.seq)) return false;
    porSeq.set(evento.seq, evento);
    ids.add(evento.id);
    return true;
  };
  atuais.forEach(acrescentar);
  const entrouAlgum = novos.map(acrescentar).some(Boolean);
  if (!entrouAlgum) return atuais;
  return [...porSeq.values()].sort((a, b) => a.seq - b.seq);
};

export const maiorSeq = (eventos: EventoSimulacao[], piso = 0): number =>
  eventos.reduce((maior, evento) => Math.max(maior, evento.seq), piso);
